<div class="password-verification-modal" [class.d--hidden]="isLoading">
  <ng-container>
    <header class="modal__header">
      <h2 id="modalLabel">{{ content.verificationText.title }}</h2>
      <button
        type="button"
        class="button modal__button--close"
        (click)="onCloseModal()"
        [attr.aria-label]="'general.label.close' | translate"
      >
        <i class="icon icon-ui-close--sm"></i>
      </button>
    </header>
    <div class="modal__content">
      <div class="modal__text" [internalInnerHtml]="content.verificationText.body" [userEventSource]="userEventSource"></div>
      <air-form #formComponent [controls]="form" [userEventSource]="userEventSource" (submitted)="submitValues($event)"> </air-form>
    </div>
    <div class="modal__footer--full-width-ends">
      <button
        type="button"
        class="button button--secondary"
        [class.button--disabled]="isResendDisabled"
        [airButtonLoading]="isResendLoading"
        [disabled]="isResendDisabled"
        (click)="resendCode($event)"
      >
        <span>{{ 'account.label.resend_verification_code' | translate }}</span>
      </button>
      <button type="submit" (click)="submit($event)" class="button form__button button--cta" [airButtonLoading]="isSubmitting">
        <span>{{ 'account.label.verify' | translate }}</span>
      </button>
    </div>
  </ng-container>
</div>
